import LineGraph from "../../LineGraph";
import ArrivalRatesPerDayTable from "../tables/ArrivalRatesPerDayTable";


import { Box } from "@chakra-ui/react";
import ReportDataTable from "../../reports/ReportDataTable";
import { ARRIVAL_RATES_SUMMARY_COLUMN_DEFINITIONS } from "../../../store/renderConfig";
import { formatNumber } from "../../../store/helpers";
import EnterpriseReportSummary from "../../reports/EnterpriseReportSummary";
import { buildArrivalInsights } from "../../../store/reportEnterpriseInsights";

const renderCell = (row, columnId) => {
  if (columnId === "scopeName") return row.scopeName;
  if (columnId === "total") return formatNumber(row.total);
  if (columnId === "average") return formatNumber(row.average);
  if (columnId === "min") return formatNumber(row.min);
  if (columnId === "max") return formatNumber(row.max);
  return null;
};

const ArrivalRatesPerDay = ({ data, renderConfig, onRenderConfigChange }) => {

  const title = `1. Entire Organization`;
  
  let {min, max, chart, average, total} = data;
  const insights = buildArrivalInsights(
    [{ ...data, scopeName: "Entire Organization" }],
    { scopeLabel: "Organization" }
  );

  if (!renderConfig?.charts?.enabled) {
    return (
      <Box className="reportContainer arrivalRatesSummaryBlock" mt="20px">
        <EnterpriseReportSummary
          title="Daily Arrival Demand Summary"
          kpis={insights.kpis}
          tables={insights.tables}
          notes={insights.notes}
        />
        <ReportDataTable
          columns={ARRIVAL_RATES_SUMMARY_COLUMN_DEFINITIONS}
          rows={[{ ...data, scopeName: "Entire Organization" }]}
          renderConfig={renderConfig}
          renderCell={renderCell}
          onSortChange={(sort) => onRenderConfigChange?.({ ...renderConfig, sort })}
        />
      </Box>
    );
  }

  return (
    <>
      <Box className="reportContainer" mt="20px">
        <EnterpriseReportSummary
          title="Daily Arrival Demand Summary"
          kpis={insights.kpis}
          tables={insights.tables}
          notes={insights.notes}
        />
        <ArrivalRatesPerDayTable
          average={(average)}
          min={(min)}
          max={(max)}
          total={(total)}
          title={title}
        />

        <Box mt="20px" mb="20px">
          <LineGraph
            chart={chart}
            height={"300px"}
            title={"Entire Organization Arrival Rates, Day by Day Comparison"}
          />
        </Box>
      </Box>
    </>
  );
};

export default ArrivalRatesPerDay;
